import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { FormGroup, ControlLabel, FormControl, HelpBlock, OverlayTrigger, Tooltip } from 'react-bootstrap'
import * as linkConst from '../../constants/link_constants'
import views from '../../routeconfig'

const SelectInput = ({
  store, attr, labelattr, valueattr, label, record, valueFilterFc,
  optionsrecord, optionsattr, errors, onChange, validationSuccess, attrValue,
  ...rest
}) => {
  const errorText = errors ? errors.get(attr) : undefined
  const validationState = errorText ? 'error' : (validationSuccess ? 'success' : null)
  const value = attrValue || record.get(attr)
  const options = optionsrecord.get(optionsattr || attr)
  valueattr = valueattr || 'value'

  function handleChange (evt) {
    if (evt.target.value.length === 0) {
      return onChange(attr, null)
    }
    const foundOpt = options
      .find((i) => i[valueattr].toString() === evt.target.value.toString())
    onChange(attr, foundOpt[valueattr])
  }

  function renderOptions (options, labelattr, valueattr, valueFilterFc) {
    const opts = [<option key={'_null__'} value={''} />]
    let idx, val, c
    for (idx = 0; idx < options.length; idx++) {
      val = options[idx]

      const jumpToNext = valueFilterFc && valueFilterFc(val)
      if (jumpToNext) continue

      const text = (typeof labelattr === 'function') ? labelattr(val, idx) : val[labelattr]
      c = <option key={idx} value={val[valueattr]}>{text}</option>
      opts.push(c)
    }
    return opts
  }

  const tooltipContent = optionsattr && options && options.length > 0 && (
    <Tooltip id={optionsattr}>
      {options[0] &&
       Object.prototype.hasOwnProperty.call(options[0], 'parent') &&
       Object.prototype.hasOwnProperty.call(options[0], 'text')
        ? 'Enum ID: '
        : 'Entity ID: '}
      <strong>{optionsattr}</strong>
    </Tooltip>
  )
  const toolTip = (label && tooltipContent) ? (
    <OverlayTrigger
      onClick={options[0] &&
       Object.prototype.hasOwnProperty.call(options[0], 'parent') &&
       Object.prototype.hasOwnProperty.call(options[0], 'text')
        ? () => store.router.goTo(views.enum_edit, {}, store, { _autoscroll: optionsattr })
        : () => store.router.goTo(store.views.entity_list, {
          entityname: (optionsattr in linkConst.SUBENTITY2ENTITY
            ? linkConst.SUBENTITY2ENTITY[optionsattr]
            : optionsattr)
        }, store, { _page: 1 })
      }
      placement='right' overlay={tooltipContent} >
      <span className='glyphicon glyphicon-list-alt cursor-pointer' style={{ fontSize: '0.75em', marginLeft: '0.7em' }} />
    </OverlayTrigger>
  ) : null
  const renderedOpts = options && options.length &&
    renderOptions(options, labelattr || 'label', valueattr, valueFilterFc)
  return (
    <FormGroup controlId={attr} validationState={validationState}>
      <ControlLabel>{label}</ControlLabel>
      {toolTip}
      <FormControl componentClass='select' placeholder='select'
        value={value || ''} onChange={handleChange} {...rest}>
        {renderedOpts}
      </FormControl>
      {errorText ? <HelpBlock>{errorText}</HelpBlock> : null}
    </FormGroup>
  )
}

SelectInput.propTypes = {
  attr: PropTypes.string.isRequired,
  errors: PropTypes.object,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  optionsattr: PropTypes.string,
  optionsrecord: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired,
  valueattr: PropTypes.string,
  labelattr: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
}

export default inject('store')(observer(SelectInput))
